module.exports = __webpack_public_path__ + "img/avatarDefault@2x.4f7a0fbb.png";